import { useState, useRef, useEffect } from "react";
import '../styles/multiSelectDropdown.css';

const MultiSelectDropdown = ({
  options = [],
  selectedValues = [],
  onChange,
  textField = "text",
  valueField = "value",
  placeholder = "Select",
}) => {

  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const isSelected = (option) =>
    selectedValues.some(v => v[valueField] === option[valueField]);

  const isAllSelected =
    options.length > 0 &&
    options.every(o =>
      selectedValues.some(v => v[valueField] === o[valueField])
    );

  const toggleOption = (option) => {

    let updated;

    if (isSelected(option)) {
      updated = selectedValues.filter(
        v => v[valueField] !== option[valueField]
      );
    } else {
      updated = [...selectedValues, option];
    }

    onChange(updated);
  };

  const toggleSelectAll = () => {

    if (isAllSelected) {
      onChange([]);
    } else {
      onChange([...options]);
    }

  };

  const displayText =
    selectedValues.length === 0
      ? placeholder
      : `${selectedValues.length} item(s) selected`;

  useEffect(() => {

    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);

  }, []);

  return (

    <div
      ref={ref}
      style={{
        position: "relative",
      }}
    >

      {/* FIELD */}

      <div
        className="form-control"
        style={{
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
        onClick={() => setOpen(!open)}
      >
        {displayText}
        <span>▼</span>
      </div>

      {/* DROPDOWN */}

      {open && (

        <div
          style={{
            position: "absolute",
            zIndex: 1000,
            width: "100%",
            maxHeight: "220px",
            overflowY: "auto",
            background: "#fff",
            border: "1px solid #7ec6e3"
          }}
        >

          {/* SELECT ALL */}

          <div
            style={{
              padding: "6px 10px",
              borderBottom: "1px solid #eee"
            }}
          >
            <label style={{ cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={toggleSelectAll}
              />
              {" "}Select All
            </label>
          </div>

          {/* OPTIONS */}

          {options.map((option) => {

            const value = option[valueField];
            const text = option[textField];
            const selected = isSelected(option);

            return (

              <div
                key={value}
                className={`ms-option ${selected ? "selected" : ""}`}
                onClick={() => toggleOption(option)}
              >

                <label>

                  <input
                    type="checkbox"
                    checked={selected}
                    onChange={() => toggleOption(option)}
                    onClick={(e) => e.stopPropagation()}
                  />

                  {text}

                </label>

              </div>

            );

          })}

        </div>

      )}

    </div>

  );
};

export default MultiSelectDropdown;